export default __webpack_public_path__ + "static/media/Magenta.8e1545f6.png";